module.exports = __webpack_public_path__ + "static/media/1285.dd99f03d.jpg";